import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { catchError, of, Subject, takeUntil } from 'rxjs';

import * as fromSettingsStore from '../../../stores/settings';
import { HelmsdeepService } from '../../services';
import { ApiErrorHandlerService } from '../../services/api-error-handler/api-error-handler.service';
import { COMMON_PATHS, REAR_PATHS } from '../../utils/constants';

@Component({
  selector: 'frodo-handed-off-confirmation',
  templateUrl: './handed-off-confirmation.component.html',
})
export class HandedOffConfirmationComponent implements OnInit, OnDestroy {
  isLoading = false;
  requestReasonEnabled = false;
  scheduleId: string;
  clientCode: string;
  flow: string;
  viewType: string;

  private unsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    private router: Router,
    private store: Store,
    private activatedRoute: ActivatedRoute,
    private helmsdeepService: HelmsdeepService,
    private apiErrorHandlerService: ApiErrorHandlerService
  ) {}

  ngOnInit(): void {
    this.isLoading = true;

    this.scheduleId = this.activatedRoute.snapshot.paramMap.get('scheduleId');
    this.clientCode = this.activatedRoute.snapshot.paramMap.get('clientCode');
    this.flow = this.activatedRoute.snapshot.paramMap.get('flow');
    this.viewType = this.activatedRoute.snapshot.paramMap.get('viewType');

    this.loadSettings();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  loadSettings() {
    this.store
      .select(fromSettingsStore.selectSettingFrodoHandedOff)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((settings) => {
        this.isLoading = false;
        this.requestReasonEnabled = settings.requestReason;
      });
  }

  onConfirm() {
    this.isLoading = true;

    if (this.requestReasonEnabled) {
      this.isLoading = false;
      return this.navigateToReasons();
    }

    this.helmsdeepService
      .orderHandOff(this.scheduleId)
      .pipe(
        catchError((error) => {
          this.isLoading = false;
          this.apiErrorHandlerService.handleApiError(error, '');

          return of(undefined);
        })
      )
      .subscribe(() => {
        this.isLoading = false;
        this.redirectBack();
      });
  }

  redirectBack() {
    this.router.navigate([`/${this.viewType}/${REAR_PATHS.DELIVERY_LIST}`]);
  }

  navigateToReasons() {
    return this.router.navigate([
      `/${this.viewType}/${COMMON_PATHS.HANDED_OFF_REASON}`,
      {
        scheduleId: this.scheduleId,
        flow: this.flow,
        clientCode: this.clientCode,
        viewType: this.viewType,
      },
    ]);
  }
}
